import {SubtemplateNode, TemplateNode} from 'graphql-client/__generated/graphqlGlobalTypes';
import {SelectSubTemplateFromTemplateCollectionsQuery} from 'notebook/entry-templates/SelectTemplateCollectionItemTree/__generated/SelectSubTemplateFromTemplateCollectionsQuery';
import {SelectTemplateFromTemplateCollectionsQuery} from 'notebook/entry-templates/SelectTemplateCollectionItemTree/__generated/SelectTemplateFromTemplateCollectionsQuery';

export type QueryTemplateCollections =
  | SelectTemplateFromTemplateCollectionsQuery['templateCollections'][number]
  | SelectSubTemplateFromTemplateCollectionsQuery['templateCollections'][number];

export type TemplateCollectionWithChildrenQuery =
  | SelectTemplateFromTemplateCollectionsQuery
  | SelectSubTemplateFromTemplateCollectionsQuery;

export type SelectTemplateCollectionItem = QueryTemplateCollections | TemplateNode | SubtemplateNode;

export function isTemplateQuery(
  q: TemplateCollectionWithChildrenQuery
): q is SelectTemplateFromTemplateCollectionsQuery {
  return Boolean((q as SelectTemplateFromTemplateCollectionsQuery).currentUser);
}

export function isTemplateNode(item: SelectTemplateCollectionItem): item is TemplateNode {
  return item.__typename === 'TemplateNode';
}

export function isSubtemplateNode(item: SelectTemplateCollectionItem): item is SubtemplateNode {
  return item.__typename === 'SubtemplateNode';
}
